var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35871 0.919336C4.23889 0.919336 0.882227 4.3029 0.882227 8.49976C0.882227 12.6914 4.23376 16.0802 8.35871 16.0802C10.4636 16.0802 12.4033 15.1943 13.7882 13.7105C9.7274 14.1405 6.15076 10.9098 6.15076 6.73918C6.15076 4.41785 7.28118 2.26506 9.15553 0.96225C8.89095 0.933715 8.62503 0.919376 8.35871 0.919336ZM8.35871 0.919336V0.319336V0.919336Z",
    stroke: "#8592C7",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.484b6a541f4807690f15bce4578f4ba3.svg";
export { ForwardRef as ReactComponent };